.editor {
  display: flex;
  align-items: center;
  gap: 20px;
}

.avatarSlot {
  position: relative;
  flex: none;
}

.photoButton {
  position: absolute;
  right: -4px;
  bottom: -4px;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 2px solid var(--color-bg);
  background: var(--color-accent);
  color: var(--color-accent-ink);
  display: grid;
  place-items: center;
  cursor: pointer;
  transition: transform 0.2s var(--ease-out);
}

.photoButton:hover {
  transform: scale(1.1) rotate(-8deg);
}

.removePhoto {
  position: absolute;
  left: -4px;
  bottom: -4px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid var(--color-bg);
  background: var(--color-surface-strong);
  cursor: pointer;
  font-size: 14px;
  line-height: 1;
}

.field {
  flex: 1;
  display: grid;
  gap: 6px;
}

.label {
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--color-text-muted);
}

.input {
  width: 100%;
  padding: 12px 14px;
  border-radius: var(--radius);
  border: 1px solid var(--color-border);
  background: rgb(0 0 0 / 0.25);
  font-size: 1.1rem;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
}

.input:focus {
  outline: none;
  border-color: var(--color-accent);
  box-shadow: 0 0 0 4px rgb(232 184 79 / 0.18);
}

.hint {
  margin: 0;
  min-height: 1.2em;
  font-size: 0.8rem;
  color: var(--color-danger);
}
